import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import Modal from 'react-bootstrap/Modal';

import { lostConnection, loadingSpinner } from '../../../actions/SurveyAction'
import './LostConnection.css';

class LostConnectionPage extends Component {
    state = {
        show:this.props.show
    }

    handleOpen = () => {
        this.setState({show:!this.state.show})
    }

    handleClose = () => {
        try {
            const { onFinishButtonClick, dispatch, closeSubmissionModal, isLastPage } = this.props;
            this.setState({show:this.state.show});
            closeSubmissionModal();

            dispatch(lostConnection(navigator.onLine));
            dispatch(loadingSpinner(false));
            // onFinishButtonClick(true);
        } catch (error) {
            console.log("Exceptions: while getting connection lost modal click:_", error.message)
        }

    }

    render() {
        console.log("Connection lost")
        return (
            <Fragment>
                {this.props.isLastPage ?
                <Modal
                    animation={true}
                    show={this.state.show}
                    aria-labelledby="contained-modal-title-vcenter"
                    onHide={this.handleClose}
                    centered
                >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Title className="header-icon">
                        <i className="fa fa-wifi" aria-hidden="true" color="#A5A5A5"></i>
                    </Modal.Title>
                    <Modal.Body className="text-center lost-modal-heading-text">
                        <strong>Please don't close this window, we may lose your answer!</strong>
                    </Modal.Body>
                    <Modal.Body className="text-center lost-modal-contain-text">
                        <span>We are sorry, but we are unable to establish a connection with our server to process your request. The network or server may be unavailable at this time. Please verify that you network connectivity and try again in few minutes.</span>
                    </Modal.Body>
                </Modal>:null}
            </Fragment>
        )
    }
}

const mapStateToProps = () => {
    return {}
}
export default React.memo(connect(mapStateToProps)(LostConnectionPage));